<template>
<!-- <div class='loading' v-if="loading"><van-loading type="spinner" color="#fff" /></div> -->
  <div class="router">
    <div class="item item3">
      <div class="line"></div>
      <div class="line"></div>
      <div class="line"></div>
    </div>
  </div>
</template>

<script>
  import { HomePostUserInfo } from "@/api/api.common";
  import { PageState } from '../lib/globalTypes';
  // import { clearCookie } from '@/utils/util';
export default {
  name: "routePage",
  data() {
    return {
      pageType: '',
      redirectUrl: '',
      vToken: '',
      query: {},
      routeAuth: [],
      loading:true
    }
  },
  mounted() {
    this.type = this.$route.query.pageType || PageState.CHECK_LOGIN;
    this.redirectUrl = this.$route.query.redirect || 'home';
    this.vToken = this.$route.query.token || window.sessionStorage.loginToken;
    this.identityCode=window.sessionStorage.identityCode;

    // 清除url传参 因为走登录是用的url，但又不能丢失参数，跳路由用的query
    let url = window.location.href.split('?')[0] + '?';
    for (let key in this.$route.query) {
      if (['code','state', 'pageType'].includes(key)) continue;
      url += `${key}=${this.$route.query[key]}&`;
      if (key != 'redirect') {
        this.query[key] = this.$route.query[key];
      }
    }
    if (url.endsWith('&') || url.endsWith('?')) url = url.slice(0, -1);
    window.history.replaceState('', 0, url);
    this.todoInit();
  },
  methods: {
    todoInit() {
      switch (this.type) {
        case PageState.CHECK_LOGIN:
          this.checkLogin();
        break;
        case PageState.NO_AUTH:
          this.noAuthHandle();
        break;
        case PageState.TOKEN_EXPIRE:
          this.tokenExpireHandle();
        break;
        case PageState.DO_LOGIN:
          this.toDoLogin();
        break;
        case PageState.DO_LOGOUT:
          this.toDoLogout();
        break;
      }
    },
    // 检查登录
    checkLogin() {
      if (this.vToken) {
        this.$store.commit("setLoginToken", {
          loginToken: this.vToken
        })
      }
      if (this.loginToken) {
        this.getUserInfos();
      } else {
        this.toDoLogin();
      }
    },
    // 用户信息
    getUserInfos() {
      HomePostUserInfo({identityCode:this.identityCode}).then((res) => {
        if (res && res.result) {
          sessionStorage.removeItem('diaNum');
          let curType=res.result.userInfo.currentUserType;
          this.$store.commit("setLoginUser", res.result);
          if(curType==3&&res.result.teacher==null){
                this.$router.push({path:'/noauth'})
                return false;
          }  
          if(curType==5&&res.result.parent==null){
                this.$router.replace({path:'/unbind',query:{bindType:1}})
                return false;
          }
          if(curType==3||curType==5){
            let params={name:this.redirectUrl,query:this.query};
            if(this.redirectUrl=='home'){
                params={name:'home'}
            }
            this.getImeis();
            this.$router.replace(params);
          }else{
            this.$router.push({path:'/noauth'})
          }
          
        }else{
          this.msg=res.message;
        }
      });
    },
    findAllLastName(arr, res) {
      arr.map(x => {
        if (!x.children || x.children.length === 0) {
          res.push(x.path)
        } else {
          this.findAllLastName(x.children, res);
        }
      })
    },
    // 无权限
    noAuthHandle() {
      this.$router.push({name: 'noAuth'});
    },
    // token过期
    tokenExpireHandle() {
      // clearCookie();
      this.toDoLogout();
    },
    // 登录
    toDoLogin() {
      let identityCode=sessionStorage.identityCode||'';
//      let redirect_url = window.location.href.replace(/#/g, "%23");
      let redirect_url = encodeURIComponent(window.location.href);
      let url = window.ENV_API.API_HOST +`/login?sysCode=app&identityCode=${identityCode}&routePath=${redirect_url}`;
      window.location.href = url;
    },
    // 登出
    toDoLogout() {debugger;
      let identityCode=sessionStorage.identityCode||'';
      window.sessionStorage.clear();
      let routePath=`${window.location.href.replace("#",
      encodeURIComponent("#") )}${encodeURIComponent("?")}identityCode=${identityCode}${
        encodeURIComponent("&")}sysCode=app`;
      let url = `${ window.ENV_API.API_HOST}/logout?token=${this.loginToken}&routePath=${routePath}`;
      window.location.href = url;
    }
  },
};
</script>
<style lang="scss" scoped>
.loading{
      position: fixed;
      width: 100%;
      height:100%;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      top: 0px;
      left: 0px;
      background:rgba(0, 0, 0,.5);
    }
//$color: #db395c;
$color: #a8a8a8;
$background-color: #f0efef;
body {
  position: relative;
  height: 100%;
  width: 100%;
}

.router {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background-color: $background-color;
}

.item {
  display: block;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: $color;
  position: relative;
  box-sizing: border-box;
  &.item3 {
    background-color: transparent;
    .line {
      width: 30%;
      height: 30%;
      border-radius: 5px;
      background-color: $color;
      position: absolute;
      bottom: 50%;
      top: 50%;
      transform: translateY(-50%);
    }
    .line:first-child {
      animation: height1 0.9s ease-in infinite;
      left: 0;
    }
    .line:nth-child(2) {
      animation: height2 0.9s ease-in infinite;
      left: 35%;
    }
    .line:last-child {
      animation: height3 0.9s ease-out infinite;
      right: 0;
    }
  }
}
@keyframes height1 {
  0% {
    height: 30%;
  }
  50% {
    height: 50%;
  }
  100% {
    height: 30%;
  }
}
@keyframes height2 {
  0% {
    height: 50%;
  }
  50% {
    height: 30%;
  }
  100% {
    height: 50%;
  }
}
@keyframes height3 {
  0% {
    height: 20%;
  }
  50% {
    height: 70%;
  }
  100% {
    height: 20%;
  }
}

.item1 {
  display: none;
}
</style>
